import db from './../db';

export default {
    put: function (url, data) {
        return new Promise(function (resolve, reject) {
            db.culture = data.culture;
            db.timezone = data.timezone;
            db.save();
            //Ok
            resolve({
                body: {}
            });
        });
    }
}



// WEBPACK FOOTER //
// ./test/data/account/save.js